var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseFilter',{attrs:{"title":"EXPERTISE","state":_vm.tags},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('Select',{attrs:{"id":"input-tags","selectProps":{
          label: 'tag',
          options: data,
          selectable: function (option) { return !option.disabled; },
          value: _vm.value,
          disabled: false,
          multiple: true,
          reduce: function (it) { return it.id; }
        },"onInput":_vm.onInput,"data-testid":"select-tags"},scopedSlots:_vm._u([{key:"selected-option",fn:function(ref){
        var option = ref.option;
return [_vm._v(" "+_vm._s(option.tag)+" ")]}},{key:"option",fn:function(ref){
        var option = ref.option;
return [_vm._v(" "+_vm._s(option.tag)+" ")]}},{key:"no-options",fn:function(){return [_vm._v(" No options ")]},proxy:true}],null,true)})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }